/* V54: hide floating purchase bar while main buy controls are visible,
   when another CTA is in view, or near the page footer. No cart handler changes. */
(function(){'use strict';
 function init(){
  if(!document.body.classList.contains('template-product')&&!document.querySelector('product-form[data-main="true"]'))return;
  var sticky=document.querySelector('.sticky-atc, .product-sticky-atc, sticky-atc');if(!sticky)return;
  var main=document.querySelector('product-form[data-main="true"]')||document.querySelector('.product-form');
  var mainButton=main&&main.querySelector('button[name="add"],button[type="submit"]');
  var footer=document.querySelector('footer, .footer, #shopify-section-footer');
  var story=document.querySelector('.orv-story__cta');
  var raf=0;
  function visible(el,top,bottom){if(!el)return false;var r=el.getBoundingClientRect();return r.bottom>top&&r.top<bottom;}
  function update(){raf=0;var mobile=matchMedia('(max-width:749px)').matches;
   var height=window.innerHeight;var nearFooter=footer&&footer.getBoundingClientRect().top<height+140;
   var hide=mobile&&(visible(mainButton,90,height-80)||visible(story,90,height-85)||nearFooter);
   document.body.classList.toggle('orv-v54-hide-sticky',!!hide);
  }
  function schedule(){if(!raf)raf=requestAnimationFrame(update)}
  addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});schedule();
  document.addEventListener('shopify:section:load',schedule);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();